<h4>Sharing data between components</h4>
<app-parent></app-parent>